import { Currency, useQuery } from '@sequencehq/api'
import { dashboard20240730Client } from '@sequencehq/api/dashboard/v20240730'
import {
  ControlledInputSelectControlFieldProps,
  InputSelectControlField
} from '@sequencehq/core-components'

type Props = Omit<
  ControlledInputSelectControlFieldProps,
  'options' | 'onChange'
> & {
  // If we want to pass an arbitrary list of currencies
  // it will stop the query from firing
  currencies?: Currency[]
  onChange: (value: Currency) => void
}

export const CurrencyInputSelectControl = ({
  currencies,
  onChange,
  ...selectControlProps
}: Props) => {
  const { data: availableCurrencies, isLoading } = useQuery(
    dashboard20240730Client.getSequenceAccountSettings,
    undefined,
    {
      select: data => data?.enabledCurrencies,
      enabled: currencies === undefined
    }
  )

  const currencyOptions = (currencies ?? availableCurrencies ?? []).map(
    currency => ({
      label: currency,
      value: currency
    })
  )

  return (
    <InputSelectControlField
      {...selectControlProps}
      disabled={isLoading}
      onChange={value => {
        onChange(value as Currency)
      }}
      options={currencyOptions}
    />
  )
}
